module.exports = {
  siteTitle: 'Erick Guimarães | Desenvolvedor de Software',
  siteDescription:
    'Erick Guimarães é desenvolvedor de software especializado em sistemas e aplicativos excepcionais e de alta qualidade.',
  siteKeywords:
    'Erick Guimarães, Erick, Guimarães, seuerick, software developer, back-end developer, web developer, java',
  siteUrl: 'https://erickguimaraes.dev',
  siteLanguage: 'pt_BR',
  lang: 'pt',

  name: 'Erick Guimarães',
  location: 'Brasília, DF',
  email: 'ericklfg@gmail.com',
  github: 'https://github.com/seuerick/',
  resume: 'Currículo',

  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/seuerick/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/erick-guimaraes/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/seuerick/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/seuerick',
    },
  ],

  navLinks: [
    {
      name: 'Sobre',
      url: '#about',
    },
    {
      name: 'Experiência',
      url: '#jobs',
    },
    {
      name: 'Contato',
      url: '#contact',
    },
  ],

  navLinksEn: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitter: {
    handle: '@seuerick',
    url: 'https://twitter.com/seuerick',
    site: 'https://twitter.com/',
    creator: '@seuerick',
    title: 'twitter @seuerick',
    description: 'twitter @seuerick',
  },

  twitterHandle: '@seuerick',
  googleAnalyticsID: 'UA-74036101-2',

  navHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
